import form from "emun.auth/register-retailer.formio";
import formioController from "webforms/formio/formio.controller";
import $geo from "webutils/services/geo";
import resolve from "ioc/resolve";
import ServiceBus from "servicestack/service-bus";
import config from "emun.auth/auth.config";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import modals from "webmodals/modals";

const DEFAULT_SUBMISSION = {
  label: "NewRetailerRequest",
  form: "NewRetailerRequest",
  data: {
    language: "en",
  },
  state: "submitted",
  saved: false,
};

export default class RegisterRetailerController {
  constructor($rootScope, $scope) {
    const $ctrl = this;
    formioController($ctrl, $scope);
    $ctrl.$geo = $geo;
    $ctrl.$rootScope = $rootScope;
    $ctrl.$scope = $scope;
    $ctrl.config = config;
    $ctrl.registrationSuccessful = false;
    $ctrl.submission = Object.assign({}, DEFAULT_SUBMISSION);
    $ctrl.bus = new ServiceBus();

    console.debug("RegisterRetailerController", { $scope, form, $ctrl });
    if ($ctrl.language === undefined) {
      $ctrl.language = "en";
    }
    $ctrl.exportText =
      $ctrl.language === "fr" ? "EXPORTER EN PDF" : "EXPORT TO PDF";

      console.info(":$ctrl.formioId", $ctrl.formioId, form);
    let formioId = $ctrl.formioId || form.formioId;
    if (
      $ctrl.retailer &&
      $ctrl.retailer.tags &&
      $ctrl.retailer.tags.RegistrationFormId
    ) {
      formioId = $ctrl.retailer.tags.RegistrationFormId[0];
    }

    console.debug(
      "formioId",
      formioId,
      $ctrl.retailer &&
        $ctrl.retailer.tags &&
        $ctrl.retailer.tags.RegistrationFormId
    );
    if (formioId) {
      $ctrl.submission.originalFormId = formioId;
      $ctrl.getFormIO(formioId).then((f) => {
        if (f) {
          $ctrl.form = f.fields;
          $ctrl.submission.form = formioId;
          $ctrl.submission.label = formioId;
          $ctrl.submission.formType = form.formType;
          if ($ctrl.retailer.tags.AuthorizationForm) {
            $ctrl.loadForm();
          }
        }

        if ($ctrl.config.registerRetailerFormOptions != undefined) {
          $ctrl.config.registerRetailerFormOptions.language =
            $ctrl.language || "en";
        }

        $ctrl.submission.data.language = $ctrl.language || "en";
        if ($ctrl.retailerId) $ctrl.loadRetailer();
        else if ($ctrl.tin) $ctrl.loadBusiness();
        });
    } else {
      $ctrl.form = form;
      if ($ctrl.config.registerRetailerFormOptions !== undefined) {
        $ctrl.config.registerRetailerFormOptions.language =
          $ctrl.language || "en";
      }

      $ctrl.submission.data.language = $ctrl.language || "en";
      if ($ctrl.retailerId) $ctrl.loadRetailer();
      else if ($ctrl.tin) $ctrl.loadBusiness();
      else $ctrl.loadForm();
    }
  }

  $apply(...args) {
    const $ctrl = this;
    $ctrl.hideForm = true;
    resolve("$timeout")(() => ($ctrl.hideForm = false), 88);
  }

  loadRetailer() {
    const $ctrl = this;
    if ($ctrl.retailerId) {
      $ctrl.bus
        .read("QueryRetailers/" + $ctrl.retailerId + ".json?Take=1")
        .then((res) => {
          $ctrl.retailer = res.data.results[0];
          $ctrl.loadForm();
        });
    } else {
      $ctrl.loadForm();
    }
  }

  loadBusiness() {
    const $ctrl = this;
    if ($ctrl.tin) {
      $ctrl.bus
        .read("QueryBusinesses.json", {tin: $ctrl.tin})
        .then((res) => {
          $ctrl.business = res.data.results[0];
          $ctrl.loadForm();
        });
    } else {
      $ctrl.loadForm();
    }
  }

  closeAndRedirect(url) {
    const $ctrl = this;
    window.location.href = url;
    $ctrl.$broadcast("$retailerRequestSubmitted");
  }

  // https://github.com/formio/ngFormio/wiki/Responding-to-Form-Events
  formSubmission(e, submission) {
    const $ctrl = this;
    console.debug("formSubmission", { e, submission, $ctrl });
    $ctrl.submission = submission;

    if (submission.data.redirectSubmissionURL && $ctrl.$session.hasEnvTag('Cms')) {
      window.location.href = submission.data.redirectSubmissionURL;
    } else if (
      config.retailerRequestRedirectUrl &&
      config.retailerRequestRedirectUrl != ""
    ) {
      window.location.href = config.retailerRequestRedirectUrl;
    } else {
			if (!$ctrl.$session.isSalesManagementMode()) {
				modals.dialog(config.registrationSuccessfulModal);
			} 
    }
    if (submission.events.RetailerRequestReceived) {
      $ctrl.onRetailerRequestReceived(
        submission.events.RetailerRequestReceived
      );
    } else {
      $ctrl.$broadcast("$retailerRequestSubmitted");
    }
    $ctrl.registrationSuccessful = true;
    this.$rootScope.$broadcast("$registrationSuccessful");

  }

  onRetailerRequestReceived(retailerRequestReceived) {
    const $ctrl = this;
    console.debug("onRetailerRequestReceived", {
      retailerRequestReceived,
      $ctrl,
    });
    $ctrl.request = {};
    $ctrl.response = retailerRequestReceived;
    $ctrl.submitted = new Date();
    $ctrl.$broadcast("$retailerRequestSubmitted", { retailerRequestReceived });
    if (
      retailerRequestReceived.userRegistered &&
      !$ctrl.$session.isSalesManagementMode()
    ) {
      $ctrl.onUserRegistered(
        retailerRequestReceived.userRegistered,
        retailerRequestReceived
      );
    }
  }

  onUserRegistered(userRegistered, retailerRequestReceived) {
    const $ctrl = this;
    const $timeout = resolve("$timeout");
    $timeout(() => $ctrl.$session.get(), 800);
    $ctrl.$broadcast("$onAuthenticated", retailerRequestReceived);
  }

  calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  exportForm() {
    const $ctrl = this;
    html2canvas(document.querySelector("#registrationForm")).then((canvas) => {
      const doc = new jsPDF("p", "mm");
      var imgData = canvas.toDataURL("image/png");
      var imgWidth = 210;
      var pageHeight = 290;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var position = 0;

      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        console.info("heightLeft", heightLeft);
        console.info("imgHeight", imgHeight);
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      doc.save("registration.pdf");
    });
  }

  startNewRegistration() {
    const $ctrl = this;
    $ctrl.registrationSuccessful = false;
    $ctrl.submission = Object.assign({}, DEFAULT_SUBMISSION);
    window.location.reload();
  }

  loadForm() {
    let $ctrl = this;
    console.debug("loadForm", $ctrl);

    if ($ctrl.$geo && $ctrl.$geo.countries) {
      $ctrl.submission.data.countries = $ctrl.$geo.countries;
    }
    if ($ctrl.$geo && $ctrl.$geo.provinces) {
      $ctrl.submission.data.provinces = $ctrl.$geo.provinces;
    }
    if ($ctrl.business) {
      $ctrl.submission.data.companyName = $ctrl.business.name;
      $ctrl.submission.data.taxId = $ctrl.business.tin;
      $ctrl.submission.data.billingAddress = $ctrl.submission.data.billingAddress1 = $ctrl.submission.data.panel2ColumnsPanelAddressLine1 = $ctrl.business.address;
      $ctrl.submission.data.billingAddress2 = $ctrl.submission.data.panel2ColumnsPanelAddressLine2 = $ctrl.business.address2;
      $ctrl.submission.data.billingCity = $ctrl.submission.data.panel2ColumnsPanelColumnsCity = $ctrl.business.city;
      $ctrl.submission.data.billingState = $ctrl.business.state;
      $ctrl.submission.data.billingZip = $ctrl.submission.data.billingZipCode = $ctrl.submission.data.billingPostalCode = $ctrl.business.postalCode;
      $ctrl.submission.data.phone = $ctrl.submission.data.phoneNumber = $ctrl.business.phone;
      $ctrl.submission.data.website = $ctrl.business.website;
      $ctrl.submission.data.email = $ctrl.business.email;
    }
    else if ($ctrl.retailer) {
      $ctrl.submission = {
        //			label: "register-retailer",
        label: "UpdateRetailer",
        data: {
          type: "",
          longForm: true,
          retailerId: $ctrl.retailer.id,
          //companyName: $ctrl.retailer.companyName,
          //panel3ColumnsPanel2Name: $ctrl.retailer.contact,
          //panel3ColumnsPanel2Email: $ctrl.retailer.email,
          //columnsComapnyPhone: $ctrl.retailer.phone,
          //columnsTaxId: $ctrl.retailer.federalTaxID,
          //columnsDealerWebsite: $ctrl.retailer.website,
          //panel2ColumnsPanelAddressLine1: $ctrl.retailer.address,
          //panel2ColumnsPanelColumnsCity: $ctrl.retailer.city,
          //panel2ColumnsPanelColumnsState: $ctrl.retailer.state,
          //panel2ColumnsPanelColumnsZipCode: $ctrl.retailer.zip,
        },
      };
      if ($ctrl.retailer.tags) {
        $ctrl.submissionId = $ctrl.retailer.tags.AuthorizationForm;
        if ($ctrl.submissionId) {
          $ctrl.bus
            .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
            .then(({ data }) => {
              if (data.results.length) {
                data.results[0].data.longForm = true;
                // pulses/978470823
                for (const p in data.results[0].data) {
                  if (
                    p.indexOf("ingCountry") &&
                    data.results[0].data[p] === "United States"
                  ) {
                    data.results[0].data[p] === "US";
                  }
                }
                $ctrl.submission = Object.assign(
                  {},
                  {
                    label: "UpdateRetailer",
                    retailerId: $ctrl.retailer.id,
                    data: data.results[0].data,
                  }
                );
              }
            });
        }
      }
    }
  }
}
